import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { CommonService } from '@core/services/common.service';
import { EmployeeService } from '@core/services/employee.service';
import { ModalService } from '@core/services/modal.service';
import { BaseModuleComponent } from '@modules/base-module/base-module.component';
import { Employee } from '@shared/models/policies/detail/employee/employee';
import moment from 'moment';

@Component({
    selector: 'app-employees',
    templateUrl: './employees.component.html',
    styleUrls: ['./employees.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class EmployeesComponent extends BaseModuleComponent implements OnInit {

  public activePage = 0;
  public minPage: number = 0;
  public maxPage: number = 1;
  public itemsPerPage = 20;
  public variant = 'short';

  private tableData: Array<Employee> = [];
  private allData: Array<Employee> = [];

  public pageTableData: Array<Employee> = [];

  public form: FormGroup;
  public dropdownValues = {};

  constructor(
    public commonService: CommonService,
    private modalService: ModalService,
    private employeesService: EmployeeService
  ) {
    super(commonService);
  }

  ngOnInit(): void {
    this.initForm();
    this.employeesService.getEmployees(this.getLoggedUser().vatNumber).subscribe(employees => {

      this.allData = this.tableData = employees.sort((a, b) => b.surname.localeCompare(a.surname)).sort((a, b) => {
        if (a.canceledDate == undefined || a.canceledDate == null) {
          return -1;
        }

        return new Date(a.canceledDate).getTime() - new Date(b.canceledDate).getTime()
      });

      this.getTableData();

    });
  }

  getTableData(page?: number): void {
    if (page == null) {
      page = 0
    }

    this.pageTableData = this.tableData.slice(page * this.itemsPerPage, (page + 1) * this.itemsPerPage);
    this.computeMaxPage();
  }

  handleChangePage($event: string) {
    if ($event == 'Next') {
      this.activePage = (this.activePage < this.maxPage) ? ++this.activePage : this.maxPage;
    } else {
      this.activePage = (this.activePage > this.minPage) ? --this.activePage : this.minPage;
    }

    this.getTableData(this.activePage);
  }

  private initForm() {

    this.form = new FormGroup({
      name: new FormControl(''),
      surname: new FormControl(''),
      dateOfBirth: new FormControl('')
    });
  }

  useFilter() {

    this.tableData = this.allData.filter((tableRow) => {
      for (const key in this.form.value) {
        if (this.form.value[key] != null && this.form.value[key].length > 0) {
          let formVal = this.form.value[key].toLowerCase();

          if (tableRow[key] === undefined) {
            return false;
          }

          if (key != 'dateOfBirth' && !tableRow[key].toLowerCase().includes(formVal)) {
            return false;
          }

          if (key == 'dateOfBirth' && !(moment(tableRow[key]).format('DD.MM.YYYY')).includes(formVal)) {
            return false;
          }

        }
      };
      return true;
    });

    this.computeMaxPage();
    this.getTableData(this.activePage);
  }

  clearFilter() {
    this.form.reset();
    this.useFilter();
  }

  private computeMaxPage() {
    this.maxPage = Math.ceil(this.tableData.length / this.itemsPerPage);
    if(this.maxPage > 0){
      this.maxPage = this.maxPage - 1;
    }

    if (this.maxPage <= this.activePage) {
      this.activePage = this.maxPage;
    }
  }

  addEmployee() {
    this.modalService.openModal('Employee', new Employee()).confirm.subscribe((submitEvent: SubmitEvent) => {
      if (submitEvent != null) {
        window.location.reload()
      }
    });
  }

  editEmployee(id: number) {
    this.modalService.openModal('Employee', this.allData.findById(id)).confirm.subscribe((submitEvent: SubmitEvent) => {
      if (submitEvent != null) {
        window.location.reload()
      }
    });
  }
}
